import { render, staticRenderFns } from "./CardValeur.vue?vue&type=template&id=3053263f&scoped=true&"
import script from "./CardValeur.vue?vue&type=script&lang=js&"
export * from "./CardValeur.vue?vue&type=script&lang=js&"
import style0 from "./CardValeur.vue?vue&type=style&index=0&id=3053263f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3053263f",
  null
  
)

export default component.exports